import type { StripState } from './tokens';

const labels: Record<StripState, string> = {
  up: 'up',
  degraded: 'degraded',
  down: 'down',
  noData: 'no data',
  centralDown: 'Central down',
  maintenance: 'planned maintenance',
};

/** Summarises a strip for screen readers: "30 days: 28 up, 2 degraded". */
export function describeStrip(days: StripState[]): string {
  const counts = new Map<StripState, number>();
  for (const d of days) counts.set(d, (counts.get(d) ?? 0) + 1);
  const parts = (Object.keys(labels) as StripState[])
    .filter((s) => counts.has(s))
    .map((s) => `${counts.get(s)} ${labels[s]}`);
  return `${days.length} days: ${parts.join(', ')}`;
}
